import { Submission } from "@/models/definitions";

export function getOrientation(submission: Submission): number {
  if (
    submission &&
    submission.exif &&
    submission.exif.Orientation !== undefined
  ) {
    return submission.exif.Orientation;
  }
  return 1;
}
